import React, {useEffect, useState} from "react"
import {
    Wizard,
    Box,
    SpaceBetween,
    Button, Header, FlashbarProps, Flashbar, Modal
} from "@amzn/awsui-components-react-v3";
import Container from '@amzn/awsui-components-react-v3/polaris/container';
import ColumnLayout from "@amzn/awsui-components-react-v3/polaris/column-layout";
import {getTaskDetails} from "src/pages/reactflow/dynamoDB";
import SNOWAttribute from "src/components/commonComponents/SNOWAttribute";
import {WorkflowStatus} from "src/constants/commonEnums";
import {startWorkflow} from "src/utils/CommonUtils";
import useFetchOnUserActionUsingSDS from "src/hooks/useFetchOnUserActionUsingSDS";
import {EntityAPIResponse} from "src/pages/NodeAddressUpdateWorkflow/NodeAddressUpdateWorkflow.interface";
import {useLocation} from "react-router-dom";
import queryString from "query-string";

const RequirementsPage = () => {
    const [ nodeDetails, setNodeDetails ] = useState<any>([])
    const [ fields, setFields ] = useState<any>([])
    const [ defFields, setDefFields ] = useState<any>([])
    const [ entityData, setEntityData ] = useState<any>([])
    const [ activeStepIndex, setActiveStepIndex  ] = useState(0);
    const [ showCancelModal, setShowCancelModel ] = useState(false)
    const [ showLaunchModal, setShowLaunchModel ] = useState(false)
    const [ launchModalButtonLoading, setLaunchModalButtonLoading ] = useState(false)
    const [ flashBarItems, setFlashBarItems ] = useState<FlashbarProps.MessageDefinition[]>([]);


    const Location = useLocation();
    const urlParams = queryString.parse(Location.search);
    const workflowName = urlParams["workflow_name"] as string;

    useEffect(() => {
        getTaskDetails(`_SnowTask`,  `WorkflowType`, workflowName).then( (items) => {
            setNodeDetails(items)
        })
    },[]);

    useEffect(() => {
       nodeDetails.map((nodeDetail => {
           for(let ele in nodeDetail.mappings) {
               let mapping ={}
               if(nodeDetail.mappings[ele].includes('$')){
                   console.log(nodeDetail.mappings[ele+"_input_type"])
                   mapping[nodeDetail.mappings[ele].slice(1)] = (nodeDetail.mappings[ele+"_input_type"]);
                   mapping['desc'] = nodeDetail.mappings[ele+"_input_desc"]
                   setFields((fields) => fields.concat(mapping))
               } else if (!ele.includes("_input")){
                   mapping[ele] = nodeDetail.mappings[ele]
                   setDefFields((defFields)=> defFields.concat(mapping))
               }
           }}))
    },[nodeDetails]);



    const setDataInState = (object, field, value) => {
        object[field] = value
        setEntityData({...object})
    }

    let i18nStrings = {
        stepNumberLabel: stepNumber =>
            `Step ${stepNumber}`,
        collapsedStepsLabel: (stepNumber, stepsCount) =>
            `Step ${stepNumber} of ${stepsCount}`,
        skipToButtonLabel: (step, stepNumber) =>
            `Skip to ${step.title}`,
        navigationAriaLabel: "Steps",
        cancelButton: "Cancel",
        previousButton: "Previous",
        nextButton: "Next",
        submitButton: "Start Workflow",
        optional: "optional"
    };

    const steps = [
        {
            title: `Requirements Page for ${workflowName}`,
            description:
                "Enter required details to start a workflow",
            content: (
                <Container
                    header={
                        <Header variant="h2">
                            Fill the Requirements Form for {workflowName}
                        </Header>
                    }
                >
                    <SpaceBetween  size="l">
                        {fields.length !=0 ? fields.map((field => {
                            var name = Object.keys(field)[0];
                            var text = Object.keys(field)[1];
                            return<SpaceBetween size="xs">
                                <SNOWAttribute
                                    id={name}
                                    value={entityData[name]}
                                    key={name}
                                    name={name}
                                    description={field[text]}
                                    type={field[name]}
                                    mandatory={true}
                                    onValidationCompletion={({ value }) =>
                                        setDataInState(entityData, name, value)

                                    }
                                    options={[
                                        {
                                            "label": "True",
                                            "id": "true"
                                        },
                                        {
                                            "label": "False",
                                            "id": "false"
                                        }
                                    ]}
                                />
                            </SpaceBetween >
                        })):null
                        }
                    </SpaceBetween>
                </Container>

            )
        },
        {
            title: "Review and launch",
            content: (
                <SpaceBetween size="xs">
                    <Header
                        variant="h3"
                        actions={
                            <Button
                                onClick={() => setActiveStepIndex(0)}
                            >
                                Edit
                            </Button>
                        }
                    >
                        Review Page
                    </Header>
                    <Container
                        header={
                            <Header variant="h2">
                               Entity Details
                            </Header>
                        }
                    >
                        <ColumnLayout
                            columns={2}
                            variant="text-grid"
                        >
                            {fields.length !=0 ? fields.map((field => {
                                var name = Object.keys(field)[0];
                                return <div>
                                    <Box variant="awsui-key-label">
                                        {name}
                                    </Box>
                                    <div>{entityData[name]? Object.keys(entityData[name]).length == 2 ? entityData[name].id: entityData[name]:null}</div>
                                </div>
                            })):null}
                        </ColumnLayout>
                    </Container>
                </SpaceBetween>
            )
        }
    ]

    function getEntityDataAPIBody() {
        let entity = {}
        let EntityAttributesList = ["physical_address_city", "physical_address_line1", "physical_address_pincode",
            "physical_country_full_name","physical_address_state", "legal_operating_company" ]
        let PipelineList = ["pipelineName", "bindleName", "fleetId", "teamAlias"]
        let AWSDataMapList = ["destinationAccountName", "sourceAccountId", "sourceAccountName"]
        const keys = Object.keys(entityData)
        let entityAttributes = {}
        let awsData = {}
        let awsDataMap = {}
        let pipelineData = {}

        keys.map((key => {
            if(EntityAttributesList.includes(key)){
                entityAttributes[key] = entityData[key]
            } else if (PipelineList.includes(key)){
                pipelineData[key] = entityData[key]
            }  else if (AWSDataMapList.includes(key)) {
                awsDataMap[key] = entityData[key]
            } else {
                entity[key] = entityData[key]
            }

        }))
        entity["WorkflowType"] = workflowName
        entity["EntityType"] = "fc"
        entity["Status"]  = WorkflowStatus.READY
        entity["CreatedBy"] = "cpallkum"
        entity["LastStatusUpdatedBy"] = "cpallkum"
        awsDataMap["destinationAccountId"] = ""
        if(awsDataMap["sourceAccountName"]){
            awsData[awsDataMap["sourceAccountName"]] = awsDataMap
        }
        entityAttributes["created_at"] = Date.now().toString(),
        entityAttributes["node_type"] = "fc"
        entityAttributes["awsDataMap"] = awsData
        entityAttributes["pipelineData"] = pipelineData
        entity["EntityData"] = entityAttributes
        entity["awsDataMap"] = awsData
        entity["pipelineData"] = pipelineData


        return {entity}
    }
    const { onClickCB: entityPostCB } = useFetchOnUserActionUsingSDS<EntityAPIResponse>();

    const postEntityData = async () => {
        setLaunchModalButtonLoading(true)
        const apiResponseEntity = await entityPostCB({
            path: "/entity",
            method: "POST",
            body: getEntityDataAPIBody(),
        });
        console.log(getEntityDataAPIBody())
        console.log(`API response returned when adding data to _SNOWEntity - ${apiResponseEntity}`)
        return apiResponseEntity.error
    };

    const startSelfServeWorkflow = async () => {
        try {
            console.log(entityData["EntityName"])
            const response = await startWorkflow(workflowName, entityData["EntityName"]);
            if(response.success) {
                console.log(`Cycle successfully started for entity ${entityData["EntityName"]}`)
                window.location.href = `../#/findEntity?name=${entityData["EntityName"]}`;

            } else {
                console.log(` Cycle couldn't be started for Entity  : ${response.errorMessage}`);
                setFlashBarItems([{
                    "header": "Failed to Start Cycle for Entity!",
                    "type": "error",
                    "content": response.errorMessage,
                    "dismissible": true,
                    onDismiss: () => setFlashBarItems([])
                }]);
                setShowLaunchModel(false)
                setLaunchModalButtonLoading(false)
            }
        } catch(error) {
            console.log(`Cycle couldn't be started for Entity : ${error}`);
            setFlashBarItems([{
                "header": "Failed to Start Cycle for Entity!",
                "type": "error",
                "content": JSON.stringify(error),
                "dismissible": true,
                onDismiss: () => setFlashBarItems([])
            }]);
            setShowLaunchModel(false)
            setLaunchModalButtonLoading(false)
        }
    }

    const launchWorkflow = async () => {
        const error = await postEntityData()
        if(error) {
            console.log(`Error launching workflow for node : ${error}`);
            setFlashBarItems([{
                header: "Error while starting workflow !!",
                type: "error",
                dismissible: true,
                onDismiss: () => setFlashBarItems([]),
                content: (
                    <>
                        The following error occurred when starting the workflow.
                        <br/>
                        {error}
                    </>
                )}
            ])
            setShowLaunchModel(false)
            setLaunchModalButtonLoading(false)
        } else {
            console.log(`Launching workflow for node with node id ${entityData["EntityName"]}`);
            await startSelfServeWorkflow()
        }
    }

    return (
        <div>
            <Modal
                onDismiss={() => setShowCancelModel(false)}
                visible={showCancelModal}
                footer={
                    <Box float="right">
                        <SpaceBetween direction="horizontal" size="xs">
                            <Button variant="link" onClick={() => setShowCancelModel(false)}>Cancel</Button>
                            <Button variant="primary" onClick={() => location.href = "../#/"}>Yes</Button>
                        </SpaceBetween>
                    </Box>
                }
                header="Confirmation"
            >
                You are about to discard your changes. Are you sure?
            </Modal>

            <Modal
                onDismiss={() => setShowLaunchModel(false)}
                visible={showLaunchModal}
                footer={
                    <Box float="right">
                        <Button variant="link" onClick={() => setShowLaunchModel(false)}>Cancel</Button>
                        <Button variant="primary" onClick={launchWorkflow} loading={launchModalButtonLoading}>
                            Agree & Launch
                        </Button>
                    </Box>
                }
                header="Confirmation"
            >
                By launching the workflow, you agree that you have verified all the requirements & everything looks good to the best of your knowledge.
            </Modal>

        <div>
            <Flashbar items={[...flashBarItems]} />
        <Wizard
            i18nStrings={i18nStrings}
            onNavigate={({ detail }) =>
                setActiveStepIndex(detail.requestedStepIndex)
            }
            activeStepIndex={activeStepIndex}
            onSubmit={()=> setShowLaunchModel(true)}
            steps={steps}
        />
        </div>
        </div>
    )
}

export default RequirementsPage;

